import { type DirectusField } from '@directus/sdk';
import {
  createContext,
  type PropsWithChildren,
  useMemo,
  useState,
} from 'react';

export type DirectusContextType = {
  readonly setFields: (fields: DirectusField[]) => void;
  readonly fields: DirectusField[] | null;
};

const DirectusContext = createContext<DirectusContextType | undefined>(
  undefined,
);

export default DirectusContext;

export const DirectusContextWrapper: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const [fields, setFields] = useState<DirectusField[] | null>(null);
  const value = useMemo(() => {
    return {
      setFields,
      fields,
    };
  }, [fields]);

  return (
    <DirectusContext.Provider value={value}>
      {children}
    </DirectusContext.Provider>
  );
};
